import React, { Component } from 'react'
import { observer, PropTypes } from 'mobx-react'

import { withRouter } from 'react-router'
import { Panel, Button, Checkbox, FormGroup } from 'react-bootstrap'
import sortBy from 'lodash.sortby'

//import DataClassChip from '../DataClassChip';

@observer
class DataClassFilter extends Component {
  constructor(props) {
    super(props)
    this.handleClear = this.handleClear.bind(this)
    this.toggleShowAll = this.toggleShowAll.bind(this)
    this.toggleDataClass = this.toggleDataClass.bind(this)

    this.state = {
      showAll: false,
    }
  }

  handleClear(evt) {
    this.props.store.dcFilter.clear()
    evt.preventDefault()
  }

  toggleShowAll() {
    this.setState({ showAll: !this.state.showAll })
  }

  toggleDataClass(evt) {
    const dataClass = evt.target.value
    if (this.props.store.dcFilter.isSelected(dataClass)) {
      this.props.store.dcFilter.deSelectItem(dataClass)
    } else {
      this.props.store.dcFilter.selectItem(dataClass)
    }

    if (this.props.store.currentPage !== 1) {
      this.props.router.push('/page/1')
    }
  }

  render() {
    const { dcFilter } = this.props.store

    let items = []
    let disabledItems = []

    // Add data classes in alpha order by label
    for (const pair of sortBy(
      [...dcFilter.menuItems.entries()],
      (pair) => pair[1].label
    )) {
      const dc = pair[0]
      const item = pair[1]
      const disabled = item.count === 0 ? true : false
      const checked = dcFilter.isSelected(dc) ? true : false

      if (disabled) {
        //disabledItems.push(<option value={dc} key={item.label} disabled={disabled}>{item.label} ({item.count})</option>);
        disabledItems.push(
          <Checkbox
            checked={checked}
            key={item.label}
            disabled={disabled}
            readOnly={true}>
            {item.label} ({item.count})
          </Checkbox>
        )
      } else if (dc==='CHEBI') {
      } else {
        //items.push(<option value={dc} key={item.label} disabled={disabled}>{item.label} ({item.count})</option>);
        items.push(
          <Checkbox
            value={dc}
            checked={checked}
            key={item.label}
            disabled={disabled}
            onChange={this.toggleDataClass}>
            {item.label} ({item.count})
          </Checkbox>
        )
      }
    }

    const title = (
      <div>
        <b>Filter by data class</b>
        <Button
          bsStyle="link"
          className="pull-right"
          onClick={this.handleClear}>
          clear
        </Button>
      </div>
    )

    const showAllTxt = this.state.showAll ? 'hide empty' : 'show all'

    return (
      <Panel header={title}>
        <FormGroup controlId="formControlsSelect">
          {items}
          {this.state.showAll && disabledItems}
        </FormGroup>
        <Button bsStyle="link" onClick={this.toggleShowAll}>
          {showAllTxt}
        </Button>
      </Panel>
    )
  }
}

DataClassFilter.propTypes = {
  store: PropTypes.observableObject.isRequired,
}

export default withRouter(DataClassFilter)
